import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=2b065c0d&scoped=true"
import script from "./joinUs.vue?vue&type=script&lang=js"
export * from "./joinUs.vue?vue&type=script&lang=js"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=2b065c0d&prod&lang=scss"
import style1 from "./joinUs.vue?vue&type=style&index=1&id=2b065c0d&prod&lang=scss"
import style2 from "./joinUs.vue?vue&type=style&index=2&id=2b065c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b065c0d",
  null
  
)

export default component.exports